export default __webpack_public_path__ + "static/media/profile_photo.85355343.png";